/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 剧院pc 演出搜索.分类
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: good.ShopCategoryCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.ShopProductDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/shop-pc/products`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
